import { Location } from "@reach/router";
import { FunctionComponent, useState } from "react";
import getRoutes from "./routes";
import AppLayout from "./components/layout/Layout";
import { User } from "./utils/helpers/types";
import UserContext from "./context/user-context";

const App: FunctionComponent = () => {
  const [user] = useState<User | null>(null);

  return (
    <UserContext.Provider value={user}>
      <Location>
        {({ location }) => (
          <AppLayout location={location}>{getRoutes(user)}</AppLayout>
        )}
      </Location>
    </UserContext.Provider>
  );
};

export default App;
